import Modal from '../components/Modal';
import FormGenerator, { FormTypes } from '../components/FormGenerator';
import SelectorEngine from '../utils/dom/selector-engine';
import EventHandler from '../utils/dom/event-handler';

const demoSteps = [
	{
		id: 1,
		step: 1,
		fieldName: 'membershipType',
		question: 'Membership',
		stepperTitle: 'Membership type',
		instructionText: 'Which membership type are you applying for?',
		errorMessage: 'Please select an option',
		options: [
			{ id: 'individual', label: 'Individual' },
			{ id: 'family', label: 'Family' }
		],
		visible: true,
		questionType: 'radio'
	},
	{
		id: 2,
		step: 2,
		fieldName: 'region',
		question: 'Region',
		stepperTitle: 'Your region',
		instructionText: 'Which region are you based in?',
		errorMessage: 'Please select a region',
		placeholder: 'Select a region',
		options: [
			{ id: 'london', label: 'London' },
			{ id: 'south-east', label: 'South East' },
			{ id: 'midlands', label: 'Midlands' },
			{ id: 'north', label: 'North' }
		],
		visible: true,
		questionType: 'select'
	}
];

const initFormModalDemo = () => {
	const formModalComponent = SelectorEngine.findOne('#form-modal-component');
	const formModalDemoTrigger = SelectorEngine.findOne('#js-open-form-modal-demo');

	if (!formModalComponent || !formModalDemoTrigger) {
		return;
	}

	let formModalInstance;
	let formGenerator;

	const createFormGenerator = () => {
		if (!formModalComponent.contentEl) {
			return null;
		}

		const instance = new FormGenerator(formModalComponent.contentEl, {
			questions: demoSteps,
			totalSteps: 2,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			isBackButtonEnabled: true,
			isExitButtonEnabled: true,
			exitButtonLabel: 'Exit',
			exitButtonHandler: () => formModalInstance.hide(),
			backButtonHandlerFirstStep: () => {
				formModalInstance.hide();
				formGenerator = null;
			},
			submitButton: {
				title: 'Complete'
			}
		});

		instance.onSubmit(() => {
			formModalInstance.hide();
		});

		return instance;
	};

	EventHandler.on(formModalDemoTrigger, 'click', () => {
		if (!formModalComponent.modalEl || !SelectorEngine.findOne('.lta-modal-dialog', formModalComponent.modalEl)) {
			return;
		}

		if (!formModalInstance) {
			formModalInstance = new Modal(formModalComponent.modalEl, { backdrop: 'static' });
		}

		if (!formGenerator) {
			formGenerator = createFormGenerator();
		}

		formModalInstance.show();
	});
};

const bootFormModalDemo = () => {
	if (!SelectorEngine.findOne('#form-modal-component')) {
		return;
	}

	initFormModalDemo();
};

if (customElements.get('lta-form-modal')) {
	requestAnimationFrame(bootFormModalDemo);
} else {
	customElements.whenDefined('lta-form-modal').then(() => requestAnimationFrame(bootFormModalDemo));
}
